import { Bot } from "lucide-react";

export function LoadingBubble() {
  return (
    <div className="flex gap-3">
      <div className="shrink-0 w-7 h-7 rounded-full bg-neutral-100 flex items-center justify-center">
        <Bot className="h-4 w-4 text-neutral-600" />
      </div>
      <div className="bg-neutral-100 rounded-lg px-4 py-3">
        <div className="flex gap-1">
          <div className="w-2 h-2 bg-neutral-400 rounded-full animate-bounce [animation-delay:-0.3s]" />
          <div className="w-2 h-2 bg-neutral-400 rounded-full animate-bounce [animation-delay:-0.15s]" />
          <div className="w-2 h-2 bg-neutral-400 rounded-full animate-bounce" />
        </div>
      </div>
    </div>
  );
}
